// extracted by mini-css-extract-plugin
export default {"submenuItem":"SubmenuItem_submenuItem__wmrDY","divider":"SubmenuItem_divider__z5pJF","content":"SubmenuItem_content__98AFF","text":"SubmenuItem_text__Xn9xg"};